var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import ButtonPreview from './ButtonPreview';

var NavPreview = (_temp2 = _class = function (_Component) {
    _inherits(NavPreview, _Component);

    function NavPreview() {
        var _temp, _this, _ret;

        _classCallCheck(this, NavPreview);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
            selected: _this.props.options[0].value
        }, _this.onSelect = function (value) {
            _this.setState({
                selected: value
            });

            if (_this.props.onSelect) {
                _this.props.onSelect(value);
            }
        }, _this.renderOption = function (option, index) {
            var selected = _this.state.selected;
            var title = option.title,
                icon = option.icon,
                value = option.value;


            return React.createElement(ButtonPreview, _extends({}, option, { key: index, label: title, icon: icon, selected: selected === value, onClick: function onClick() {
                    return _this.onSelect(value);
                } }));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    NavPreview.prototype.componentDidMount = function componentDidMount() {
        require('./NavPreview.scss');
    };

    NavPreview.prototype.render = function render() {
        var options = this.props.options;


        return React.createElement(
            'nav',
            { className: 'nav-preview', role: 'option' },
            React.createElement(
                'div',
                { className: 'admin-buttongroup  admin-buttongroup--preview' },
                options.map(this.renderOption)
            )
        );
    };

    return NavPreview;
}(Component), _class.defaultProps = {
    options: [{
        value: "p1",
        title: "Preview",
        icon: "code"
    }, {
        value: "p2",
        title: "Preview 2",
        icon: "code"
    }]
}, _temp2);
NavPreview.propTypes = process.env.NODE_ENV !== "production" ? {
    options: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired
    }))
} : {};


export default NavPreview;